import {
  ADD_SEARCH_TAG,
  REMOVE_SEARCH_TAG,
  CLEAR_SEARCH_TAG,
} from './constants'

export const addSearchTag = tag => ({
  type: ADD_SEARCH_TAG,
  tag,
})

export const removeSearchTag = tag => ({
  type: REMOVE_SEARCH_TAG,
  tag,
})

export const clearSearchTag = tag => ({
  type: CLEAR_SEARCH_TAG,
})
